const maxWidth = 500;

export {
	maxWidth
};
